import React from "react";
import * as c from "./categoryButton.module.scss";
import classNames from "classnames";
import { Link } from "gatsby";

const CategoryButton = ({ className, label = "", selected = false, linkTo = null, onClick }) => {
  const Element = linkTo ? Link : "button";

  return (
    <Element
      className={classNames(className, c.button, { [c.selected]: selected })}
      {...(linkTo && { to: linkTo })}
      onClick={onClick}
    >
      {label}
    </Element>
  );
};

export { CategoryButton };
